module.exports = __webpack_public_path__ + "media/images/front/about/point1_img03-c5d7a7d04c65770726d3c273fc9cf598.jpg";